export enum PatientSelectionModalKeys {
  LIST = 'LIST',
  CREATE = 'CREATE',
}
